import MasterSlider from './master-slider';

export default class MasterSliderDesktop extends MasterSlider {
    constructor(...args) {
        super(...args);
    }

    _animate(){

        // animation next image
        TweenLite.to(this.dom.bgImg[this.params.next], 0.5, {
            autoAlpha: 1
        });

        // animation bullets
        this.dom.bullet[this.params.current].classList.remove('active');
        this.dom.bullet[this.params.next].classList.add('active');

        // update attribut
        this.dom.slideImage.setAttribute("data-current", this.params.next);

        // animation legend
        this.animLegend.fromTo(this.dom.legend[this.params.current], 0.6, {autoAlpha: 1}, {autoAlpha: 0, force3D:true, ease: Power3.easeInOut}, 0 )
            .fromTo(this.dom.legend[this.params.next], 0.8, {y: -60, autoAlpha: 1}, {y: 0, force3D:true, ease: Power3.easeInOut}, 0.5 )

        // fade current image
        TweenLite.to(this.dom.bgImg[this.params.current], 1, {
            autoAlpha: 0,
            onComplete: () => {
                // end
                this.params.current = this.params.next;
                this.params.canClick = true;
            }
        });
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/master-slider/master-slider.desktop.js